// Single source of truth for role → visible top-nav sections.
// Mirrors the backend policy in crates/dashboard/src/roles.rs.

import { TOP_NAVS, type TopNavId } from '../layouts/navigation';

export type Role = 'admin' | 'maker' | 'quant' | 'user';

const ALL_NAVS = TOP_NAVS.map((n) => n.id) as TopNavId[];

const NAV_BY_ROLE: Record<Role, TopNavId[]> = {
  // 注意:tweet、hn 与 github 的数据都走 /api/openfish 网关(admin-only,
  // 见 openfish_gateway.rs);要放开给其他角色需同步放宽网关的角色列表。
  admin: ALL_NAVS, // 全部,含 radar、trader 与 invest(全球投资)
  // maker 与 quant 都进合并后的 trader tab;进去后按 PanelDef.roles 过滤,
  // maker 只见 Maker 组、quant 只见 Quant 组(见 auth/panelAccess.ts)。
  maker: ['home', 'trader', 'signals'],
  quant: ['home', 'trader', 'signals'],
  user: ['signals'], // signals only
};

/** Sections this role may see, in TOP_NAVS order. Unknown role ⇒ minimal. */
export function visibleNavs(role: Role | null | undefined): TopNavId[] {
  if (!role) return ['signals'];
  return NAV_BY_ROLE[role] ?? ['signals'];
}

export function canSee(role: Role | null | undefined, nav: TopNavId): boolean {
  return visibleNavs(role).includes(nav);
}

/** Path the role should land on (first visible section). */
export function landingFor(role: Role | null | undefined): string {
  return `/${visibleNavs(role)[0] ?? 'signals'}`;
}

/** Whether this role uses the `/ws` stream (feed + grid push). `user` doesn't. */
export function usesWebSocket(role: Role | null | undefined): boolean {
  return !!role && role !== 'user';
}
